import { Component, HostBinding, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NavService } from '../../services/nav-menu.service';

export interface NavMenuItem {
  displayName: string;
  route: string;
  children?: NavMenuItem[];
}

@Component({
  selector: 'app-nav-menu-list-item',
  templateUrl: './nav-menu-list-item.component.html',
  styleUrls: ['./nav-menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('1000ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})

export class NavMenuListItemComponent implements OnInit, OnDestroy {
  expanded: boolean;
  paddingClass = 'padding_';
  padingCount = 1;
  mobileQuery: MediaQueryList;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavMenuItem;
  @Input() depth: number;
  @Input() isChild: boolean;

  // tslint:disable-next-line: variable-name
  private _mobileQueryListener: () => void;

  constructor(
    public navService: NavService,
    public router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
    this.mobileQuery = media.matchMedia('(min-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.expanded = false;
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
      }
    });
  }

  onItemSelected(item: NavMenuItem): void {
    if ((!item.children || !item.children.length)) {
      this.router.navigate([item.route]);
      if (this.isMobile()) {
        this.navService.closeNav();
      }
    } else if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  isMobile() {
    return !this.mobileQuery.matches;
  }

  toggleSidenav() {
    this.navService.toggle();
  }
}
